import React from 'react';
import { useEntity } from '@backstage/plugin-catalog-react';
import { InfoCard } from '@backstage/core-components';
import { Chip } from '@material-ui/core';

export const CustomEntityLabelsCard = ({
  variant,
}: {
  variant?: 'gridItem';
}) => {
  const { entity } = useEntity();
  const labels = entity.metadata.labels || {};

  if (Object.keys(labels).length === 0) {
    return null;
  }

  return (
    <InfoCard title="Labels" variant={variant}>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
        {Object.entries(labels).map(([key, value]) => (
          <Chip
            key={key}
            label={`${key}: ${value}`}
            size="small"
            color="primary"
            variant="outlined"
            style={{ margin: '4px' }}
          />
        ))}
      </div>
    </InfoCard>
  );
};
